/* TooltipRow.tsx generated by @compiled/babel-plugin v0.28.8 */
import "./TooltipRow.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import { NON_HOVER_OPACITY } from '../../../charts/common/constants/constants';
import { element } from '../../../core/elements/create';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const outerDivCss = null;
const innerDivCss = null;
const colorItemCss = null;
const labelItemCss = null;
const valueItemCss = null;
function TooltipRow(_ref) {
  let {
    color,
    label,
    value,
    isFocussed
  } = _ref;
  const labelColor = isFocussed === undefined ? "var(--ds-text-subtlest, #626F86)" : isFocussed ? "var(--ds-text-accent-gray-bolder, #091E42)" : "var(--ds-text-subtlest, #626F86)";
  return /*#__PURE__*/_jsx("div", {
    role: "list",
    className: ax(["_1wpz1fhb _1bah1yb4 _4cvr1h6o _1e0c116y"]),
    children: /*#__PURE__*/_jsxs("div", {
      role: "listitem",
      className: ax(["_u5f3ftgi _1bah1y6m _4cvr1h6o _zulpftgi _1e0c1txw _v5641w7c"]),
      children: [/*#__PURE__*/_jsx("div", {
        className: ax(["_1bah1y6m _4cvr1h6o _zulpftgi _1e0c1txw _v5641w7c"]),
        children: /*#__PURE__*/_jsx("svg", {
          style: {
            width: 12,
            height: 12,
            borderRadius: 2,
            opacity: isFocussed === undefined ? 1 : isFocussed ? 1 : NON_HOVER_OPACITY
          },
          className: ax(["_v56414fr"]),
          children: /*#__PURE__*/_jsx("rect", {
            width: "100%",
            height: "100%",
            fill: color
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          color: labelColor
        },
        className: ax(["_ect41wi2 _1wybdlk8 _k48p1nn1 _slp31hna _v564zqrc"]),
        children: label
      }), /*#__PURE__*/_jsx("div", {
        style: {
          color: labelColor
        },
        className: ax(["_ect41wi2 _1wybdlk8 _k48p1nn1 _vwz41q5e _slp31hna _v564zqrc"]),
        children: value
      })]
    })
  });
}
const _TooltipRow = element(TooltipRow);
export { _TooltipRow as TooltipRow };